module.exports = __webpack_public_path__ + "img/44_37.1bf43c96.png";